/* eslint-disable no-shadow */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useState } from "react";
import * as Sentry from "@sentry/react";
import Button from "../../../components/common/Button";
import style from "./GohonzonConsentUrl.styles";
import Toast from "../../../components/common/Toast";
import InputField from "../../../components/common/new/InputField/InputField";
import Member from "../../../services/api/member";
import Loader from "../../../components/common/Loader/Loader";

function GohonzonConsentUrl() {
  const [showToast, setShowToast] = useState(null);
  const [memberDetails, setMemberDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [memberId, setMemberId] = useState("");

  const fetchMemberDetails = async (id) => {
    try {
      setLoading(true);
      const { data } = await Member.getGohonzonConsentForMember(id);
      setMemberDetails(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      Sentry.captureException(err);
      setShowToast({
        message: err.message,
        severity: "error",
      });
      setMemberDetails(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (memberId.trim() !== "") {
      await fetchMemberDetails(memberId);
    }
  };

  const getGohonzonType = (gohonzon) => {
    if (gohonzon === "OKATAKI_GOHONZON") {
      return "GOHONZON";
    }
    return gohonzon?.length ? gohonzon.split("_")[0] : "NA";
  };

  // const handleCopy = () => {
  //   if (memberDetails) {
  //     const consentUrl = memberDetails.consentUrl || "";
  //     navigator.clipboard
  //       .writeText(consentUrl)
  //       .then(() => {
  //         setShowToast({
  //           message: "Consent URL copied to clipboard",
  //           severity: "success",
  //         });
  //       })
  //       .catch((err) => {
  //         setShowToast({
  //           message: `Error copying Consent URL: ${err.message}`,
  //           severity: "error",
  //         });
  //       });
  //   }
  // };

  const handleCopy = () => {
    if (memberDetails) {
      const consentUrl = memberDetails.consentUrl || "";
      const tempInput = document.createElement("input");
      document.body.appendChild(tempInput);
      tempInput.value = consentUrl;
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);

      setShowToast({
        message: "Consent URL copied",
        severity: "success",
      });
    }
  };

  return (
    <Box sx={style.container}>
      <form onSubmit={handleSubmit}>
        <Box style={{ ...style.search, justtifyContent: "space-between" }}>
          <Box width="40%">
            <InputField
              name="searchMember"
              label="Member ID"
              value={memberId}
              onChange={(e) => setMemberId(e.target.value)}
            />
          </Box>
          <Box width="40%" />
          <Button label="Search" type="submit" />
        </Box>
        {memberDetails && (
          <Box
            style={{
              ...style.search,
              justifyContent: "space-between",
              paddingTop: "20px",
            }}
          >
            <Box width="20%">
              <InputField
                name="searchMember"
                label="Gohonzon Type"
                value={getGohonzonType(memberDetails?.gohonzonType) || ""}
              />
            </Box>
            <Box width="20%">
              <InputField
                name="searchMember"
                label="App ID"
                value={memberDetails?.id || ""}
              />
            </Box>
            <Box width="40%">
              <InputField
                name="searchMember"
                label="Consent Url"
                value={memberDetails?.consentUrl || ""}
              />
            </Box>
            <Box width="20%">
              <Button label="Copy URL" onClick={handleCopy} />
            </Box>
          </Box>
        )}
      </form>
      {loading && <Loader />}
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </Box>
  );
}

export default GohonzonConsentUrl;
